<template>
  <div class="glossary-dialog-container">
    <GlossariesList v-if="currentComponent === 'GlossariesList'" @open-glossary="editGlossary" />
    <GlossaryOverview v-else :glossary="selectedGlossary" @navigate-back="cancelEdit" @save="handleSave" />
  </div>
</template>

<script>
import { ref } from 'vue';
import useGlossaries from '~/composables/useGlossaries';
import GlossariesList from '~/components/glossary/GlossariesList';
import GlossaryOverview from '~/components/glossary/GlossaryOverview';

export default {
  components: { GlossaryOverview, GlossariesList },
  setup() {
    const { GLOSSARY_COMPONENT, saveGlossary } = useGlossaries();
    const selectedGlossary = ref(null);
    const currentComponent = ref(GLOSSARY_COMPONENT.list);

    const editGlossary = (glossary) => {
      selectedGlossary.value = { ...glossary };
      currentComponent.value = GLOSSARY_COMPONENT.overview;
    };

    const handleSave = async (headers, rows, glossary, publicValue, newName) => {
      const response = await saveGlossary(headers, rows, glossary, publicValue, newName);
      selectedGlossary.value = response || null;
    };

    const cancelEdit = () => {
      selectedGlossary.value = null;
      currentComponent.value = GLOSSARY_COMPONENT.list;
    };

    return {
      cancelEdit,
      currentComponent,
      editGlossary,
      handleSave,
      selectedGlossary,
    };
  },
};
</script>

<style scoped lang="scss">
.glossary-dialog-container {
  /* Style your dialog/panel here */
  display: flex;
  flex-direction: column;
  height: 100vh; /* Take full viewport height */
  width: 100%;
  position: fixed; /* Use fixed positioning */
  top: 0;
  left: 0;
  z-index: 1000; /* Ensure it's above other content */
}
</style>
